import { Delete } from "@mui/icons-material";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";

import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";
import { SETTLEMENT_STYLES } from "../../style/styles";

export default function OtherLiensBalanceDropdownMenu({
  anchorEl,
  open,
  onClose,
  onEdit,
  onDelete,
  expenseId = "",
  canEdit = false,
  canDelete = false,
}) {
  return (
    <Menu
      id={`other-liens-balance-row-menu-${expenseId}`}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          sx: SETTLEMENT_STYLES.menuPaper,
        },
      }}
    >
      {canEdit ? (
        <MenuItem id={`other-liens-balance-row-menu-edit-${expenseId}`} onClick={onEdit}>
          <ListItemText primary="Edit" />
          <ListItemIcon sx={SETTLEMENT_STYLES.menuListItemIcon}>
            <Svg
              name={SvgEnum.HisEdit3}
              color={HNSColors.primary[500]}
              sx={SETTLEMENT_STYLES.menuEditIcon}
            />
          </ListItemIcon>
        </MenuItem>
      ) : null}
      {canDelete ? (
        <MenuItem id={`other-liens-balance-row-menu-delete-${expenseId}`} onClick={onDelete}>
          <ListItemText primary="Delete" sx={SETTLEMENT_STYLES.deleteText} />
          <ListItemIcon sx={SETTLEMENT_STYLES.menuListItemIcon}>
            <Delete fontSize="small" sx={SETTLEMENT_STYLES.deleteIcon} />
          </ListItemIcon>
        </MenuItem>
      ) : null}
    </Menu>
  );
}
